import * as constants from '../constants';
import { createReducer } from '../../../utils';

const initialState = {
  requestInformationLink: {},
  applyOnlineLink: {},
  learnMoreLinks: [],
  hasRegisteredChanges: false,
  nextOrder: 0,
  customProfiles: [],
  draftImagesData: {
    profileImageFile: '',
    croppedImageBlob: '',
    scannedPhotoUrls: {},
  },
  areNewLinks: true,
  areNewProfiles: true,
  hasLinkUpdates: false,
  hasProfileUpdates: false,
};

export default createReducer(initialState, {
  [constants.SET_ARE_NEW_LINKS]: (state, { areNewLinks }) => ({
    ...state, areNewLinks,
  }),
  [constants.SET_REQUEST_INFO_LINK]: (state, { requestInformationLink, hasRegisteredChanges = true }) => ({
    ...state,
    requestInformationLink,
    hasRegisteredChanges: state.hasProfileUpdates || hasRegisteredChanges,
    hasLinkUpdates: hasRegisteredChanges,
  }),
  [constants.SET_APPLY_ONLINE_LINK]: (state, { applyOnlineLink, hasRegisteredChanges = true }) => ({
    ...state, applyOnlineLink, hasRegisteredChanges: state.hasProfileUpdates || hasRegisteredChanges, hasLinkUpdates: hasRegisteredChanges,
  }),
  [constants.SET_LEARN_MORE_LINKS]: (state, { learnMoreLinks, hasRegisteredChanges = true }) => ({
    ...state, learnMoreLinks, hasRegisteredChanges: state.hasProfileUpdates || hasRegisteredChanges, hasLinkUpdates: hasRegisteredChanges,
  }),
  [constants.ADD_LEARN_MORE_LINK]: (state, newLink) => ({
    ...state,
    hasRegisteredChanges: true,
    learnMoreLinks: [...state.learnMoreLinks, newLink],
    nextOrder: state.nextOrder + 1,
    hasLinkUpdates: true,
  }),
  [constants.EDIT_LEARN_MORE_LINK]: (state, { learnMoreLink, hasRegisteredChanges = true }) => ({
    ...state,
    hasRegisteredChanges: state.hasProfileUpdates || hasRegisteredChanges,
    learnMoreLinks: [...state.learnMoreLinks.filter((e) => e.order !== learnMoreLink.order), learnMoreLink],
    hasLinkUpdates: hasRegisteredChanges,
  }),
  [constants.SET_NEXT_LINK_ORDER]: (state, nextOrder) => ({
    ...state, nextOrder,
  }),
  [constants.REMOVE_LEARN_MORE_LINK]: (state, { linkToRemove }) => (
    {
      ...state,
      learnMoreLinks: state.learnMoreLinks.filter((elem) => elem !== linkToRemove),
      hasRegisteredChanges: true,
      hasLinkUpdates: true,
    }
  ),
  [constants.RESET_LINKS_AND_PROFILES_CHANGES_FLAG]: (state, { areNewLinks, areNewProfiles = initialState.areNewProfiles }) => ({
    ...state,
    hasRegisteredChanges: false,
    areNewLinks,
    areNewProfiles,
    hasLinkUpdates: false,
    hasProfileUpdates: false,
  }),
  [constants.UPDATE_CUSTOM_PROFILES]: (state, updateProfileData) => ({
    ...state,
    hasRegisteredChanges: true,
    hasProfileUpdates: true,
    customProfiles: [
      ...state.customProfiles.slice(0, updateProfileData.updatedProfileIndex),
      updateProfileData.customProfile,
      ...state.customProfiles.slice(updateProfileData.updatedProfileIndex + 1),
    ],
  }),
  [constants.REMOVE_CUSTOM_PROFILE]: (state, profileIndex) => ({
    ...state,
    hasRegisteredChanges: true,
    hasProfileUpdates: true,
    customProfiles: [...state.customProfiles.slice(0, profileIndex), ...state.customProfiles.slice(profileIndex + 1)],
  }),
  [constants.ADD_CUSTOM_PROFILE]: (state, customProfile) => ({
    ...state,
    hasRegisteredChanges: true,
    hasProfileUpdates: true,
    customProfiles: [...state.customProfiles, customProfile],
  }),
  [constants.INITIALIZE_CUSTOM_PROFILES]: (state, { customProfiles, hasRegisteredChanges, areNewProfiles }) => ({
    ...state, customProfiles, hasRegisteredChanges, areNewProfiles,
  }),
  [constants.SET_PROFILE_PHOTO_FILE]: (state, { file }) => ({
    ...state,
    draftImagesData: {
      ...state.draftImagesData,
      profileImageFile: file,
    },
  }),
  [constants.SET_PROFILE_CROPPED_PHOTO_FILE]: (state, { croppedImageBlob }) => ({
    ...state,
    draftImagesData: {
      ...state.draftImagesData,
      croppedImageBlob,
    },
  }),
  [constants.SET_PROFILE_PHOTO_S3_SCANNED_URI]: (state, { profileIndex, scannedPhotoUrl }) => ({
    ...state,
    hasRegisteredChanges: true,
    draftImagesData: {
      ...state.draftImagesData,
      scannedPhotoUrls: {
        ...state.draftImagesData.scannedPhotoUrls,
        [profileIndex]: scannedPhotoUrl,
      },
    },
  }),
});
